<template>
    <div>
        good
    </div>
</template>

<script>
    import {userLogin} from '@/api/api'
    import {userRegister} from '@/api/api'
    import {getUserInfo} from '@/api/api'
    import {userSignList} from '@/api/api'
    import {userSign} from '@/api/api'
    export default {
        name: "logininfo",
        data(){
            return{
                code:this.$route.query.code,
                state:this.$route.query.state,
            }
        },
        created(){
            this.doLogin()
        },
        method:{
            doLogin(){
                let params = {
                    code:this.code
                }
                userLogin(params).then(res=>{
                    if (res.code==0){
                        localStorage.setItem("token",res.data.openId)
                        // this.doRegister()
                        this.getUserInfo()
                    }
                })
            },
            getUserInfo(){
                getUserInfo().then(res=>{
                    console.log(res)
                    if (res.code==0){
                        // this.getUserSignList()
                        this.$router.replace('')
                    }else if (res.code == 400001){
                        this.doRegister()
                    }
                })
            },
            doRegister(){
                let params = {
                    telephone:'834794792'
                }
                userRegister(params).then(res=>{
                    if (res.code==0){

                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>